/* eslint-disable */
import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import MyTaskKanbanKitBody from "components/MyTaskComponents/MyTaskKanban/MyTaskKanbanKitBody";

const MyTaskKanbanKit = () => {
  // -------- for title ------------
  useEffect(() => {
    document.title = "My Task";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="mytask" />

      <MyTaskKanbanKitBody />
    </main>
  );
};

export default MyTaskKanbanKit;
